import { useMemo } from "react";
import { JsonParam, StringParam, useQueryParam } from "use-query-params";

import type { Conversation } from "../types";

interface HighlightContext {
  highlight: Conversation["highlight"];
  lastActivityAt: number;
}

export default function useActiveConversationState() {
  const [accountId, setAccountId] = useQueryParam("accountId", StringParam);
  const [conversationUrn, setConversationUrn] = useQueryParam(
    "urn",
    StringParam,
  );
  const [highlightContext, setHighlightContext] =
    useQueryParam<HighlightContext>("highlight", JsonParam);

  function setActiveConversationState(
    conversationUrn: string,
    accountId: string,
    highlightContext: HighlightContext,
  ) {
    setConversationUrn(conversationUrn);
    setAccountId(accountId);
    setHighlightContext(highlightContext);
  }

  function resetActiveConversation() {
    setConversationUrn(undefined);
    setAccountId(undefined);
    setHighlightContext(undefined);
  }

  const activeConversationState = useMemo(
    () =>
      conversationUrn && accountId
        ? { conversationUrn, accountId, highlightContext }
        : undefined,
    [conversationUrn, accountId, highlightContext],
  );

  return {
    activeConversationState,
    setActiveConversationState,
    resetActiveConversation,
  };
}
